import React from "react";

import { useTranslation } from "react-i18next";

import type { School } from "@local-logic/client";

import { primitiveUtils } from "@local-logic/core/utils";

import * as globalStyles from "../styles";
import * as styles from "./styles";

export function SchoolAttributes({
  attributes,
  boardAttributes,
  onLinkClick,
}: {
  attributes?: School["school_attributes"];
  boardAttributes?: School["school_board_attributes"];
  onLinkClick?: () => void;
}) {
  const { t } = useTranslation(["common"]);

  if (!attributes || Object.keys(attributes).length === 0) {
    return null;
  }

  return (
    <div className={globalStyles.content}>
      <ul>
        {typeof attributes?.grades !== "undefined" && (
          <li className={styles.item} data-testid="school-attributes-grades">
            <span className={styles.label}>
              {t("common:map.marker.schoolAttributes.levels")}
            </span>
            : {primitiveUtils.string.capitalize(attributes.grades)}
          </li>
        )}

        {typeof attributes?.programs !== "undefined" && (
          <li className={styles.item} data-testid="school-attributes-programs">
            <span className={styles.label}>
              {t("common:map.marker.schoolAttributes.programs")}
            </span>
            : {attributes.programs.join(", ")}
          </li>
        )}

        {typeof attributes?.languages !== "undefined" && (
          <li className={styles.item} data-testid="school-attributes-languages">
            <span className={styles.label}>
              {t("common:map.marker.schoolAttributes.languages")}
            </span>
            : {attributes.languages.join(", ").toUpperCase()}
          </li>
        )}

        {typeof attributes?.types !== "undefined" && (
          <li className={styles.item} data-testid="school-attributes-types">
            <span className={styles.label}>
              {t("common:map.marker.schoolAttributes.types")}
            </span>
            : {attributes.types.join(", ")}
          </li>
        )}

        {typeof boardAttributes?.url !== "undefined" && (
          <li className={styles.item} data-testid="school-attributes-board">
            <span className={styles.label}>
              {t("common:map.marker.schoolAttributes.board")}
            </span>
            :{" "}
            <a
              onClick={onLinkClick}
              data-testid="school-attributes-board-link"
              href={boardAttributes.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {boardAttributes?.name || boardAttributes?.url}
            </a>
          </li>
        )}
      </ul>
    </div>
  );
}
